module.exports = __webpack_public_path__ + "static/media/SportsStore_25.c395a167.webp";